/**
 *
 *     |o     o    |          |
 * ,---|.,---..,---|,---.,---.|__/
 * |   |||   |||   ||---'`---.|  \
 * `---'``---|``---'`---'`---'`   `
 *       `---'    [media solutions]
 *
 * @copyright   (c) digidesk - media solutions
 * @link            https://www.digidesk.de
 */

import './page/ddms-paypal-ext'
import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Module.register(
    'ddms-paypal',
    {
        type:        'plugin',
        name:        'Paypal Export',
        title:       'ddms-paypal.general.titleTextModule',
        description: 'ddms-paypal.general.descriptionTextModule',
        icon:        'small-questionmark',
        color:       '#A092F0',

        snippets: {
            'de-DE': deDE,
            'en-GB': enGB
        },
        routes:   {
            ext: {
                component: 'ddms-paypal-ext',
                path:      'ext'
            }
        },

        navigation: [
            {
                id:       'ddms-paypal',
                label:    'ddms-paypal.general.titleTextModule',
                color:    '#ff3d58',
                path:     'ddms.paypal.ext',
                position: 120,
                parent:   'sw-order'
            }
        ]
    }
);

